import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { PetitionProvider } from '../../providers/petition/petition';
import { Petition } from '../../models/petition';


@IonicPage()
@Component({
  selector: 'page-tasks',
  templateUrl: 'tasks.html',
})
export class TasksPage {

  petitions;

  constructor(
    private loadingCtrl: LoadingController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public petitionProvider: PetitionProvider,
  ) {
    petitionProvider.getUserTasks().then(observable => {
      this.petitions = observable;
    });
  }

  async aprove(petition: Petition) {
    let loading = this.loadingCtrl.create();
    loading.present()

    await this.petitionProvider.aprove(petition);

    loading.dismiss()
  }

  async reject(petition: Petition) {
    let loading = this.loadingCtrl.create();
    loading.present()

    await this.petitionProvider.reject(petition);
    
    loading.dismiss()
  }

  info(petition) {
    this.navCtrl.push('PetitionInfoPage', { mode:'tasks', petition: petition});
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks/tasks.ts